module.exports = __webpack_public_path__ + "img/spa.d4164b98.svg";